import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=d83d3e60&"
import script from "./CSelect.vue?vue&type=script&lang=js&"
export * from "./CSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports